import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { noop } from 'utils/func';

export const REQUEST_PROPERTIES = 'REQUEST_PROPERTIES';
export const RECEIVE_PROPERTIES = 'RECEIVE_PROPERTIES';
export const FINISH_PROPERTIES_FETCHING = 'FINISH_PROPERTIES_FETCHING';
export const RECEIVE_PROPERTIES_ERROR = 'RECEIVE_PROPERTIES_ERROR';
export const SET_NO_ROUTE_ACCESS = 'SET_NO_ROUTE_ACCESS';

const url = `${config.apiBasePath}/properties`;

const requestPropertiesAction = {
  type: REQUEST_PROPERTIES,
};

const finishPropertiesFetchingAction = {
  type: FINISH_PROPERTIES_FETCHING,
};

export function receiveProperties(properties) {
  return {
    type: RECEIVE_PROPERTIES,
    ...properties,
  };
}

export function receivePropertiesError(json) {
  return {
    type: RECEIVE_PROPERTIES_ERROR,
    error: json.error,
  };
}

export function setNoRouteAccess(action) {
  return {
    type: SET_NO_ROUTE_ACCESS,
    action,
  };
}

// not a redux action, do not dispatch it directly, use fetchProperties
export function getProperties(dispatch, network, callback = noop) {
  dispatch(requestPropertiesAction);

  return network.get(url)
    .then((properties) => {
      dispatch(receiveProperties(properties));
      dispatch(finishPropertiesFetchingAction);
      callback();
    })
    .catch(err => {
      dispatch(receivePropertiesError(err.data || UNKNOWN_ERROR));
    });
}

export function fetchProperties(onPropertiesFetched) {
  return (dispatch, getState, { network }) => getProperties(dispatch, network, onPropertiesFetched);
}
